<template>
  <div class="container">
    <SmartTitle
      heading="1"
      weight="medium"
    >Exportar Bases de Capilaridade</SmartTitle>
    <div class="align-center bg-white main border-default p-2">
      <SmartTitle
        weight="medium"
        class="mb-2 ml-1 py-2"
      >Informação do Distribuidor</SmartTitle>
      <div
        class="flex main"
        v-if="!loading"
      >
        <div class="w-full aux">
          <VAutocomplete
            placeholder="Informe o nome do DB"
            :items="distributors"
            label="Nome do Distribuidor"
            item-text="name"
            item-value="id"
            v-model="selectedDbId"
            name="Nome"
            multiple
            v-validate="'required'"
            class="pb-1-4 mb-3"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span :id="`distributor-${index}`">{{ item.name }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >+ (Outros)</span>
            </template>
          </VAutocomplete>
          <SmartInput
            v-model="date_from"
            :not-after="date_to"
            type="date-picker"
            label="Data de Ativação"
            class="pb-1-4 mb-3"
          />
          <VSelect
            label="Regional"
            placeholder="TCN"
            :items="views"
            item-text="name"
            name="selectedViews"
            item-value="id"
            v-model="selectedViews"
            v-validate="'required'"
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span :id="`regional-${views.indexOf(item)}`">{{ item.name }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >+ (Outros)</span>
            </template></VSelect>
        </div>
        <div class="w-full aux pl-3">
          <VSelect
            placeholder="Selecione o tipo de DB"
            :items="typeDB"
            label="Tipo de Distribuidor"
            item-text="typeDB"
            item-value="typeDB"
            v-model="selectedTypeDB"
            name="typeDB"
            v-validate="'required'"
            class="pb-1-4 mb-3"
          >
            <template v-slot:item="{ item }">
              <div class="v-list__tile__content">
                <div :id="`db-type-${typeDB.indexOf(item)}`" class="v-list__tile__title">{{ item }}</div>
              </div>
            </template>
          </VSelect>
          <SmartInput
            v-model="date_to"
            :not-after="notAfterOneMonth"
            :not-before="date_from"
            type="date-picker"
            name="Data final"
            label="Fim de Ativação"
            class="pb-1-4 mb-3"
          />
          <VSelect
            placeholder="DDD"
            :items="listDDD"
            label="DDD"
            item-text="ddd"
            item-value="id"
            v-model="selectedDDDS"
            name="ddd"
            multiple
            v-validate="'required'"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span :id="`ddd-${index}`">{{ item.ddd }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >+ (Outros)</span>
            </template>
          </VSelect>
        </div>
      </div>
      <SmartSkeletonLoading
        v-else
        :items="5"
        :height="4"
      />
      <SmartTitle
        weight="medium"
        class="mb-2 ml-1 py-2"
      >Informações do PDV</SmartTitle>
      <div
        class="flex main"
        v-if="!loading"
      >
        <div class="w-full aux">
          <VSelect
            placeholder="Selecione o tipo de Capilaridade"
            :items="typeCapillarity"
            label="Tipo de Capilaridade"
            v-model="selectedTypeCapillarity"
            name="typeCapillarity"
            v-validate="'required'"
            class="pb-1-4 mb-3"
          >
            <template v-slot:item="{ item }">
              <div class="v-list__tile__content">
                <div :id="`type-capillarity-${typeCapillarity.indexOf(item)}`" class="v-list__tile__title">{{ item }}</div>
              </div>
            </template>
          </VSelect>
          <SmartInput
            v-model="recharge_curve"
            placeholder="Informe a Curva de Recarga"
            name="recharge_curve"
            label="Curva Recarga TIM"
            class="pb-1-4 mb-3"
            v-validate="'required'"
            :mask="'H'"
          />
        </div>
        <div class="w-full aux pl-3">
          <SmartInput
            v-model="chip_curve"
            placeholder="Informe a Curva de Chip TIM"
            name="chip_curve"
            label="Curva Chip TIM"
            class="pb-1-4 mb-3"
            v-validate="'required'"
            :mask="'H'"
          />
          <SmartInput
            v-model="cpfCnpj"
            name="cpfCnpj"
            id="cpfCnpj"
            placeholder="94.224.991/0001-30"
            label="CNPJ/CPF"
            :mask="['##.###.###/####-##', '###.###.###-##']"
            v-validate="changeValidateCpfCnpj"
            :error="errors.first('cpfCnpj')"
          />
        </div>
      </div>
      <SmartSkeletonLoading
        v-else
        :items="5"
        :height="4"
      />
      <div class="flex main">
        <div class="w-full aux flex justify-end">
          <SmartButton
            @click="filterBase"
          >Exportar Agora</SmartButton>
        </div>
      </div>
    </div>
    <SmartModal
      v-if="modal"
      v-bind="modal"
      @close.prevent="modal = null"
      @return="tryExportFile"
    >
      {{ modal.text }}
    </SmartModal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { formatUSDate } from 'utils';
import { downloadCsvFile } from 'utils/blob';

export default {
  data() {
    return {
      loading: false,
      modal: null,
      resultFilter: {},
      date_from: '',
      date_to: '',
      typeDB: ['NACIONAL', 'REGIONAL'],
      selectedTypeDB: '',
      selectedChannels: [],
      selectedViews: [],
      typeCapillarity: ['CHIP', 'RECARGA', 'HÍBRIDO'],
      selectedTypeCapillarity: '',
      chip_curve: '',
      recharge_curve: '',
      selectedDbId: [],
      selectedDDDS: [],
      cpfCnpj: ''
    };
  },
  computed: {
    ...mapGetters({
      viewsExecutivas: 'view/views',
      capillarityBase: 'exportBases/capillarityBase',
      distributors: 'distributors/distributors',
      channels: 'channel/channels',
      listDDD: 'distributors/ddds'
    }),
    changeValidateCpfCnpj() {
      return this.cpfCnpj
        .replace(/[./-]/g, '')
        .length === 14 ? 'cnpj' : 'cpf';
    },
    views() {
      return this.viewsExecutivas.flatMap(item => item.views);
    },
    notAfterOneMonth() {
      const futureDate = this.date_from !== '' ? new Date(this.date_from) : new Date();
      futureDate.setMonth(futureDate.getMonth() + 1);
      return futureDate;
    },
    canFetchData() {
      return (
        !this.loading
        && this.date_from !== ''
        && this.date_from != null
        && this.date_to !== ''
        && this.date_to != null
      );
    }
  },
  methods: {
    ...mapActions({
      fetchViewsRelated: 'view/fetchViewsRelated',
      fetchCapillarityBase: 'exportBases/fetchCapillarityBase',
      fetchAllDistributors: 'distributors/fetchAllDistributors',
      fetchDDDS: 'distributors/fetchDDDS'
    }),
    filterBase() {
      this.resultFilter = {
        dataInicio: formatUSDate(this.date_from),
        dataFim: formatUSDate(this.date_to),
        view: this.selectedViews,
        channel: this.selectedChannels,
        typeCapillarity: this.selectedTypeCapillarity,
        simCardCurve: this.chip_curve,
        rechargeCurve: this.recharge_curve,
        db_id: this.selectedDbId,
        ddd: this.selectedDDDS,
        tipo_db: this.selectedTypeDB,
        cnpj: this.cpfCnpj
      };
      this.showConfirmModal();
    },
    tryExportFile() {
      this.showLoadModal();
      // Gambeta
      const gambeta = setTimeout(this.showEmailWillBeSendModal, 60 * 2000);
      this.fetchCapillarityBase(this.resultFilter)
        .then(({ data }) => {
          const currentDate = moment().format('MMMM Do YYYY, h:mm:ss a');
          downloadCsvFile({ filename: currentDate, file: data });
          clearTimeout(gambeta);
          this.showSucessModal();
        })
        .catch(() => {
          this.showErrorModal();
        });
    },
    showEmailWillBeSendModal() {
      this.modal = {
        type: 'success',
        title: 'Sua exportação será enviada por email',
        icon: 'accepted',
        buttonText: 'Ok, Continuar',
        text: 'Cheque a caixa de email pois em breve lhe enviaremos sua exportação.'
      };
    },
    showLoadModal() {
      this.modal = {
        type: 'default',
        title: 'Carregando Arquivo...',
        icon: 'smooth',
        text: 'Estamos exportando o arquivo, aguarde um instante...'
      };
    },
    showSucessModal() {
      this.modal = {
        type: 'success',
        title: 'Exportação concluída com sucesso!',
        icon: 'accepted',
        buttonText: 'Ok, Continuar',
        text: 'Parabéns, sua exportação foi concluída.'
      };
    },
    showConfirmModal() {
      this.modal = {
        type: 'warning',
        title: 'Exportar Tabela',
        icon: 'alert',
        buttonText: 'Não, cancelar',
        secondButton: 'Sim, Exportar',
        text: 'Você realmente deseja exportar esta tabela?'
      };
    },
    showErrorModal() {
      this.modal = {
        type: 'warning',
        title: 'Ops!',
        icon: 'alert',
        buttonText: 'Cancelar',
        text: 'Algo inesperado aconteceu ao exportar o arquivo, tente novamente.'
      };
    }

  },
  async mounted() {
    this.loading = true;
    await this.fetchViewsRelated();
    await this.fetchAllDistributors();
    await this.fetchDDDS();
    this.loading = false;
  }
};
</script>

<style scoped>
</style>
<style lang="scss">
.grid-channels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 10px;
  overflow: hidden;
}
</style>
